<template>
  <div id="app-menu">
    <div class="side-menu-bar">
        <div class="side-close" onclick="history.back();">
            <a href="#">
                <img src="../assets/images/mainIcon01.png" alt="icon-menu">
            </a>
        </div>
        <ul>
            <li><a href="#"><span>메뉴1</span></a></li>
            <li><a href="#"><span>메뉴2</span></a></li>
            <li><a href="#"><span>메뉴3</span></a></li>
            <li><a href="#"><span>메뉴4</span></a></li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMenu'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppMenu.vue